import { SelectFormControlItem } from '@snelstart/ui-form-controls';
import { AdminEntity, AdministratieApiSst } from '@snelstart-ventures/fiscaal/domain-logic';
import { BalanceProviderAdministrationSelectionContext } from '../balance-providers/administration-selection-dialog/administration-selection-dialog.model';

export const BOOLEAN_OPTIONS: SelectFormControlItem<boolean>[] = [
    { value: true, label: 'Ja' },
    { value: false, label: 'Nee' },
];

export const BEDRIJFSKLASSE_OPTIONS: SelectFormControlItem<string>[] = [
    { value: 'MICRO', label: 'Micro' },
    { value: 'KLEIN', label: 'Klein' },
    { value: 'MIDDELGROOT', label: 'Middelgroot', disabled: true },
    { value: 'GROOT', label: 'Groot', disabled: true },
];

export const SBI_CODE_OPTIONS: SelectFormControlItem<string>[] = [
    { value: '0001', label: '0001 - Code nog niet vastgesteld' },
    { value: '01110', label: '01110 - Teelt van andere granen dan rijst, en van peulgewassen en oliehoudende zaden' },
    { value: '01120', label: '01120 - Teelt van rijst' },
    { value: '01131', label: '01131 - Teelt van groenten in de volle grond' },
    { value: '01132', label: '01132 - Teelt van groenten onder glas' },
    { value: '01133', label: '01133 - Teelt van paddenstoelen' },
    { value: '01134', label: '01134 - Teelt van aardappelen en overige wortel- en knolgewassen' },
    { value: '01140', label: '01140 - Teelt van suikerriet' },
    { value: '01150', label: '01150 - Teelt van tabak' },
    { value: '01160', label: '01160 - Teelt van vezelgewassen' },
    { value: '01191', label: '01191 - Teelt van snijbloemen en snijheesters in de volle grond' },
    { value: '01192', label: '01192 - Teelt van snijbloemen en snijheesters onder glas' },
    { value: '01193', label: '01193 - Teelt van voedergewassen' },
    { value: '01199', label: '01199 - Teelt van overige eenjarige gewassen (rest)' },
    { value: '01210', label: '01210 - Teelt van druiven' },
    { value: '01220', label: '01220 - Teelt van tropisch en subtropisch fruit' },
    { value: '01230', label: '01230 - Teelt van citrusvruchten' },
    { value: '01241', label: '01241 - Teelt van appels en peren' },
    { value: '01242', label: '01242 - Teelt van steenvruchten' },
    { value: '01251', label: '01251 - Teelt van aardbeien in de volle grond' },
    { value: '01252', label: '01252 - Teelt van aardbeien onder glas' },
    { value: '01253', label: '01253 - Teelt van houtig kleinfruit en noten in de volle grond' },
    { value: '01254', label: '01254 - Teelt van houtig kleinfruit onder glas' },
    { value: '01260', label: '01260 - Teelt van oliehoudende vruchten' },
    { value: '01270', label: '01270 - Teelt van gewassen bestemd voor de vervaardiging van dranken' },
    { value: '01280', label: '01280 - Teelt van specerijgewassen en van aromatische en medicinale gewassen' },
    { value: '01290', label: '01290 - Teelt van overige meerjarige gewassen' },
    { value: '01301', label: '01301 - Teelt van bloembollen' },
    { value: '01302', label: '01302 - Teelt van perkplanten in de volle grond' },
    { value: '01303', label: '01303 - Teelt van perkplanten onder glas' },
    { value: '01304', label: '01304 - Teelt van potplanten onder glas' },
    { value: '01305', label: '01305 - Teelt van boomkwekerijgewassen in de volle grond' },
    { value: '01309', label: '01309 - Teelt van overige sierplanten in de volle grond' },
    { value: '01411', label: '01411 - Houden van melkvee' },
    { value: '01412', label: '01412 - Opfokken van jong melkvee' },
    { value: '01421', label: '01421 - Houden van vleeskalveren' },
    { value: '01422', label: '01422 - Overige vleesveehouderij, inclusief houden van buffels' },
    { value: '01430', label: '01430 - Fokken en houden van paarden en overige paardachtigen' },
    { value: '01440', label: '01440 - Fokken en houden van kamelen en overige kameelachtigen' },
    { value: '01451', label: '01451 - Fokken en houden van schapen' },
    { value: '01452', label: '01452 - Fokken en houden van geiten' },
    { value: '01461', label: '01461 - Fokken van varkens voor vermeerdering' },
    { value: '01462', label: '01462 - Houden van varkens voor vleesproductie' },
    { value: '01463', label: '01463 - Activiteiten van (deels) gesloten varkensbedrijven' },
    { value: '01471', label: '01471 - Opfokken en houden van leghennen' },
    { value: '01472', label: '01472 - Opfokken en houden van vleeskuikens' },
    { value: '01473', label: '01473 - Opfokken en houden van ouderdieren kippen' },
    { value: '01479', label: '01479 - Opfokken en houden van overig pluimvee' },
    { value: '01481', label: '01481 - Fokken en houden van edelpelsdieren' },
    { value: '01489', label: '01489 - Fokken en houden van overige dieren (rest)' },
    { value: '01500', label: '01500 - Akker- en/of tuinbouw in combinatie met het fokken en houden van dieren' },
    { value: '01610', label: '01610 - Dienstverlening voor de teelt van gewassen' },
    { value: '01620', label: '01620 - Dienstverlening voor het fokken en houden van dieren' },
    { value: '01630', label: '01630 - Behandeling van gewassen na de oogst en van zaden voor vermeerdering' },
    { value: '01700', label: '01700 - Jacht en aanverwante diensten' },
    { value: '02100', label: '02100 - Bosbouw' },
    { value: '02200', label: '02200 - Exploitatie van bossen' },
    { value: '02300', label: '02300 - Verzamelen van in het wild groeiende producten met uitzondering van hout' },
    { value: '02400', label: '02400 - Dienstverlening voor de bosbouw' },
    { value: '03110', label: '03110 - Zee- en kustvisserij' },
    { value: '03120', label: '03120 - Binnenvisserij' },
    { value: '03210', label: '03210 - Aquacultuur in zee' },
    { value: '03220', label: '03220 - Aquacultuur in zoet water' },
    { value: '03300', label: '03300 - Ondersteunende activiteiten voor visserij en aquacultuur' },
    { value: '05100', label: '05100 - Winning van steenkool' },
    { value: '05200', label: '05200 - Winning van bruinkool' },
    { value: '06100', label: '06100 - Winning van aardolie' },
    { value: '06200', label: '06200 - Winning van aardgas' },
    { value: '07100', label: '07100 - Winning van ijzererts' },
    { value: '07210', label: '07210 - Winning van uranium- en thoriumerts' },
    { value: '07290', label: '07290 - Winning van overige non-ferrometaalertsen' },
    { value: '08110', label: '08110 - Winning van siersteen, kalksteen, gips, leisteen en overige steensoorten' },
    { value: '08120', label: '08120 - Winning van grind, zand, klei en kaolien' },
    { value: '08910', label: '08910 - Winning van mineralen voor de chemische en de kunstmestindustrie' },
    { value: '08920', label: '08920 - Winning van turf' },
    { value: '08930', label: '08930 - Winning van zout' },
    { value: '08990', label: '08990 - Overige winning van delfstoffen, n.e.g.' },
    { value: '09100', label: '09100 - Dienstverlening voor de winning van aardolie en aardgas' },
    { value: '09900', label: '09900 - Dienstverlening voor de winning van overige delfstoffen' },
    { value: '10110', label: '10110 - Verwerking en conservering van vlees, met uitzondering van vlees van gevogelte' },
    { value: '10120', label: '10120 - Verwerking en conservering van vlees van gevogelte' },
    { value: '10130', label: '10130 - Vervaardiging van vleesproducten' },
    { value: '10200', label: '10200 - Verwerking en conservering van vis en van schaal- en weekdieren' },
    { value: '10310', label: '10310 - Verwerking en conservering van aardappelen' },
    { value: '10320', label: '10320 - Vervaardiging van groente- en fruitsappen' },
    { value: '10390', label: '10390 - Overige verwerking en conservering van groenten en fruit' },
    { value: '10410', label: '10410 - Vervaardiging van oliën en vetten, met uitzondering van margarine en vergelijkbare eetbare vetten' },
    { value: '10420', label: '10420 - Vervaardiging van margarine en vergelijkbare eetbare vetten' },
    { value: '10510', label: '10510 - Vervaardiging van zuivelproducten' },
    { value: '10520', label: '10520 - Vervaardiging van roomijs en ander consumptie-ijs' },
    { value: '10610', label: '10610 - Vervaardiging van maalderijproducten' },
    { value: '10620', label: '10620 - Vervaardiging van zetmeel en zetmeelproducten' },
    { value: '10710', label: '10710 - Vervaardiging van brood en vers banketbakkerswerk' },
    { value: '10720', label: '10720 - Vervaardiging van beschuit, biscuit en houdbaar banketbakkerswerk' },
    { value: '10730', label: '10730 - Vervaardiging van deegwaren' },
    { value: '10810', label: '10810 - Vervaardiging van suiker' },
    { value: '10821', label: '10821 - Verwerking van cacao' },
    { value: '10822', label: '10822 - Vervaardiging van chocolade en suikerwerk' },
    { value: '10830', label: '10830 - Verwerking van thee en koffie' },
    { value: '10840', label: '10840 - Vervaardiging van sauzen, specerijen en kruiderijen' },
    { value: '10850', label: '10850 - Vervaardiging van kant- en klaarmaaltijden en schotels' },
    { value: '10860', label: '10860 - Vervaardiging van gehomogeniseerde voedingspreparaten en dieetvoeding' },
    { value: '10890', label: '10890 - Vervaardiging van overige voedingsmiddelen (rest)' },
    { value: '10910', label: '10910 - Vervaardiging van veevoeders' },
    { value: '10920', label: '10920 - Vervaardiging van voeders voor huisdieren' },
    { value: '11010', label: '11010 - Destilleren, rectificeren en mengen van sterk alcoholische dranken' },
    { value: '11020', label: '11020 - Vervaardiging van wijn uit druiven' },
    { value: '11030', label: '11030 - Vervaardiging van cider en overige gefermenteerde vruchtendranken' },
    { value: '11040', label: '11040 - Vervaardiging van overige niet-gedistilleerde gefermenteerde dranken' },
    { value: '11050', label: '11050 - Vervaardiging van bier' },
    { value: '11060', label: '11060 - Vervaardiging van mout' },
    { value: '11070', label: '11070 - Vervaardiging van frisdranken en gebotteld water' },
    { value: '12000', label: '12000 - Vervaardiging van tabaksproducten' },
    { value: '13100', label: '13100 - Bewerken en spinnen van textielvezels' },
    { value: '13200', label: '13200 - Weven van textiel' },
    { value: '13300', label: '13300 - Textielveredeling' },
    { value: '13910', label: '13910 - Vervaardiging van gebreide en gehaakte stoffen' },
    { value: '13920', label: '13920 - Vervaardiging van huishoudtextiel en geconfectioneerde artikelen voor stoffering' },
    { value: '13930', label: '13930 - Vervaardiging van vloerkleden en tapijten' },
    { value: '13940', label: '13940 - Vervaardiging van koord, touw, bindgaren en netten' },
    { value: '13950', label: '13950 - Vervaardiging van ongeweven stoffen en artikelen daarvan' },
    { value: '13960', label: '13960 - Vervaardiging van overig technisch en industrieel textiel' },
    { value: '13990', label: '13990 - Vervaardiging van overige textielproducten (rest)' },
    { value: '14100', label: '14100 - Vervaardiging van gebreide en gehaakte kleding' },
    { value: '14210', label: '14210 - Vervaardiging van bovenkleding' },
    { value: '14220', label: '14220 - Vervaardiging van onderkleding' },
    { value: '14230', label: '14230 - Vervaardiging van werkkleding' },
    { value: '14240', label: '14240 - Vervaardiging van kleding van leer en van bont' },
    { value: '14290', label: '14290 - Vervaardiging van overige kleding en accessoires, n.e.g.' },
    { value: '15110', label: '15110 - Looien, verven en bewerken van leder en bont' },
    { value: '15120', label: '15120 - Vervaardiging van koffers, tassen, zadel- en tuigmakerswerk van ongeacht welk materiaal' },
    { value: '15200', label: '15200 - Vervaardiging van schoeisel' },
    { value: '16110', label: '16110 - Zagen en schaven van hout' },
    { value: '16120', label: '16120 - Verwerking en afwerking van hout' },
    { value: '16210', label: '16210 - Vervaardiging van fineer en van panelen op basis van hout' },
    { value: '16220', label: '16220 - Vervaardiging van panelen voor parketvloeren' },
    { value: '16230', label: '16230 - Vervaardiging van overig schrijn- en timmerwerk' },
    { value: '16240', label: '16240 - Vervaardiging van houten emballage' },
    { value: '16250', label: '16250 - Vervaardiging van houten deuren en kozijnen' },
    { value: '16260', label: '16260 - Vervaardiging van vaste brandstoffen uit plantaardige biomassa' },
    { value: '16270', label: '16270 - Afwerking van houten producten' },
    { value: '16280', label: '16280 - Vervaardiging van overige producten van hout en van producten van kurk, riet of vlechtwerk' },
    { value: '17110', label: '17110 - Vervaardiging van papierpulp' },
    { value: '17121', label: '17121 - Vervaardiging van grafisch papier en karton' },
    { value: '17122', label: '17122 - Vervaardiging van papier en karton voor verpakking' },
    { value: '17129', label: '17129 - Vervaardiging van overig papier en karton' },
    { value: '17211', label: '17211 - Vervaardiging van verpakkingsmiddelen van papier en karton' },
    { value: '17212', label: '17212 - Vervaardiging van golfpapier en -karton' },
    { value: '17220', label: '17220 - Vervaardiging van huishoudelijke en sanitaire papierwaren' },
    { value: '17230', label: '17230 - Vervaardiging van kantoorbenodigdheden van papier' },
    { value: '17240', label: '17240 - Vervaardiging van behangpapier' },
    { value: '17250', label: '17250 - Vervaardiging van overige papier- en kartonwaren' },
    { value: '18110', label: '18110 - Drukken van dagbladen' },
    { value: '18121', label: '18121 - Drukken van boeken en dergelijke' },
    { value: '18122', label: '18122 - Drukken van tijdschriften' },
    { value: '18123', label: '18123 - Drukken van reclame' },
    { value: '18124', label: '18124 - Drukken van verpakkingen' },
    { value: '18125', label: '18125 - Drukken van formulieren' },
    { value: '18129', label: '18129 - Overige activiteiten op het gebied van drukwerk (rest)' },
    { value: '18130', label: '18130 - Voorbereidende activiteiten voor papieren en digitale output' },
    { value: '18140', label: '18140 - Activiteiten van binderijen en aanverwante diensten' },
    { value: '18200', label: '18200 - Reproductie van opgenomen media' },
    { value: '19100', label: '19100 - Vervaardiging van cokesovenproducten' },
    { value: '19200', label: '19200 - Vervaardiging van geraffineerde aardolieproducten en van producten uit fossiele brandstoffen' },
    { value: '20110', label: '20110 - Vervaardiging van industriële gassen' },
    { value: '20120', label: '20120 - Vervaardiging van kleurstoffen en pigmenten' },
    { value: '20130', label: '20130 - Vervaardiging van overige anorganische basischemicaliën' },
    { value: '20141', label: '20141 - Vervaardiging van petrochemische producten' },
    { value: '20149', label: '20149 - Vervaardiging van overige organische basischemicaliën (geen petrochemische producten)' },
    { value: '20150', label: '20150 - Vervaardiging van kunstmeststoffen en stikstofverbindingen' },
    { value: '20160', label: '20160 - Vervaardiging van kunststoffen in primaire vormen' },
    { value: '20170', label: '20170 - Vervaardiging van synthetische rubber in primaire vormen' },
    { value: '20200', label: '20200 - Vervaardiging van pesticiden, ontsmettingsmiddelen en overige landbouwchemicaliën' },
    { value: '20300', label: '20300 - Vervaardiging van verf, vernis en soortgelijke coatings, drukinkt en mastiek' },
    { value: '20410', label: '20410 - Vervaardiging van zeep, was-, reinigings- en polijstmiddelen' },
    { value: '20420', label: '20420 - Vervaardiging van parfums en cosmetica' },
    { value: '20510', label: '20510 - Vervaardiging van vloeibare biobrandstoffen' },
    { value: '20590', label: '20590 - Vervaardiging van overige chemische producten (rest)' },
    { value: '20600', label: '20600 - Vervaardiging van synthetische vezels' },
    { value: '21100', label: '21100 - Vervaardiging van farmaceutische grondstoffen' },
    { value: '21200', label: '21200 - Vervaardiging van farmaceutische producten' },
    { value: '22110', label: '22110 - Vervaardiging en loopvlakvernieuwing van rubberbanden en vervaardiging van binnenbanden' },
    { value: '22120', label: '22120 - Vervaardiging van overige producten van rubber' },
    { value: '22210', label: '22210 - Vervaardiging van platen, vellen, buizen en profielen van kunststof' },
    { value: '22220', label: '22220 - Vervaardiging van kunststof verpakkingsmateriaal' },
    { value: '22230', label: '22230 - Vervaardiging van kunststof deuren en kozijnen' },
    { value: '22240', label: '22240 - Vervaardiging van kunststofartikelen voor de bouw' },
    { value: '22250', label: '22250 - Verwerking en afwerking van kunststofproducten' },
    { value: '22260', label: '22260 - Vervaardiging van overige kunststofproducten' },
    { value: '23110', label: '23110 - Vervaardiging van vlakglas' },
    { value: '23120', label: '23120 - Vormen en bewerken van vlakglas' },
    { value: '23130', label: '23130 - Vervaardiging van holglas' },
    { value: '23140', label: '23140 - Vervaardiging van glasvezels' },
    { value: '23150', label: '23150 - Vervaardiging en bewerking van overig glas, inclusief technisch glaswerk' },
    { value: '23200', label: '23200 - Vervaardiging van vuurvaste producten' },
    { value: '23310', label: '23310 - Vervaardiging van keramische tegels en plavuizen' },
    { value: '23320', label: '23320 - Vervaardiging van bakstenen, tegels en producten voor de bouw, van gebakken klei' },
    { value: '23410', label: '23410 - Vervaardiging van huishoudelijk en sieraardewerk' },
    { value: '23420', label: '23420 - Vervaardiging van sanitair aardewerk' },
    { value: '23430', label: '23430 - Vervaardiging van keramische isolatoren en isolerende fittingen' },
    { value: '23440', label: '23440 - Vervaardiging van overig technisch keramisch aardewerk' },
    { value: '23450', label: '23450 - Vervaardiging van overige producten van keramiek' },
    { value: '23510', label: '23510 - Vervaardiging van cement' },
    { value: '23520', label: '23520 - Vervaardiging van kalk en gips' },
    { value: '23611', label: '23611 - Vervaardiging van producten van beton voor de bouw' },
    { value: '23612', label: '23612 - Vervaardiging van producten van kalkzandsteen voor de bouw' },
    { value: '23620', label: '23620 - Vervaardiging van gipsproducten voor de bouw' },
    { value: '23630', label: '23630 - Vervaardiging van stortklare beton' },
    { value: '23640', label: '23640 - Vervaardiging van mortel' },
    { value: '23650', label: '23650 - Vervaardiging van vezelcement' },
    { value: '23660', label: '23660 - Vervaardiging van overige producten van beton, cement en gips' },
    { value: '23700', label: '23700 - Houwen, bewerken en afwerken van natuursteen' },
    { value: '23910', label: '23910 - Vervaardiging van schuurmiddelen' },
    { value: '23990', label: '23990 - Vervaardiging van overige niet-metaalhoudende minerale producten, n.e.g.' },
    { value: '24100', label: '24100 - Vervaardiging van ijzer en staal en van ferrolegeringen' },
    { value: '24200', label: '24200 - Vervaardiging van stalen buizen, pijpen, holle profielen en bijbehorende fittingen' },
    { value: '24310', label: '24310 - Koudtrekken van staven' },
    { value: '24320', label: '24320 - Koudwalsen van bandstaal' },
    { value: '24330', label: '24330 - Koudvervormen of koudfelsen' },
    { value: '24340', label: '24340 - Koudtrekken van draad' },
    { value: '24410', label: '24410 - Productie van edelmetalen' },
    { value: '24420', label: '24420 - Productie van aluminium' },
    { value: '24430', label: '24430 - Productie van lood, zink en tin' },
    { value: '24440', label: '24440 - Productie van koper' },
    { value: '24450', label: '24450 - Productie van overige non-ferrometalen' },
    { value: '24460', label: '24460 - Bewerking van nucleaire brandstoffen' },
    { value: '24510', label: '24510 - Gieten van ijzer' },
    { value: '24520', label: '24520 - Gieten van staal' },
    { value: '24530', label: '24530 - Gieten van lichte metalen' },
    { value: '24540', label: '24540 - Gieten van overige non-ferrometalen' },
    { value: '25110', label: '25110 - Vervaardiging van metalen constructiewerken en delen daarvan' },
    { value: '25120', label: '25120 - Vervaardiging van metalen deuren en kozijnen' },
    { value: '25210', label: '25210 - Vervaardiging van radiatoren, stoomgeneratoren en ketels voor centrale verwarming' },
    { value: '25220', label: '25220 - Vervaardiging van overige metalen tanks, reservoirs en containers' },
    { value: '25300', label: '25300 - Vervaardiging van wapens en munitie' },
    { value: '25400', label: '25400 - Smeden en bewerken van metaal en poedermetallurgie' },
    { value: '25510', label: '25510 - Coating van metalen' },
    { value: '25520', label: '25520 - Warmtebehandeling van metaal' },
    { value: '25530', label: '25530 - Metaalbewerking' },
    { value: '25610', label: '25610 - Vervaardiging van scharen, messen en bestekken' },
    { value: '25620', label: '25620 - Vervaardiging van hang- en sluitwerk' },
    { value: '25630', label: '25630 - Vervaardiging van gereedschap' },
    { value: '25910', label: '25910 - Vervaardiging van stalen vaten en soortgelijke containers' },
    { value: '25920', label: '25920 - Vervaardiging van verpakkingsmiddelen van licht metaal' },
    { value: '25930', label: '25930 - Vervaardiging van draadproducten en van kettingen en veren' },
    { value: '25940', label: '25940 - Vervaardiging van bouten, schroeven, moeren en dergelijke' },
    { value: '25990', label: '25990 - Vervaardiging van overige metalen producten, n.e.g.' },
    { value: '26110', label: '26110 - Vervaardiging van elektronische componenten' },
    { value: '26120', label: '26120 - Vervaardiging van elektronische printplaten' },
    { value: '26200', label: '26200 - Vervaardiging van computers en randapparatuur' },
    { value: '26300', label: '26300 - Vervaardiging van communicatieapparatuur' },
    { value: '26400', label: '26400 - Vervaardiging van consumentenelektronica' },
    { value: '26510', label: '26510 - Vervaardiging van instrumenten en apparatuur voor meten, controle en navigatie' },
    { value: '26520', label: '26520 - Vervaardiging van uurwerken' },
    { value: '26600', label: '26600 - Vervaardiging van bestralingsapparatuur en van elektromedische en elektrotherapeutische apparatuur' },
    {
        value: '26700',
        label: '26700 - Vervaardiging van optische instrumenten, magnetische en optische dragers en fotografische apparatuur',
    },
    { value: '27110', label: '27110 - Vervaardiging van elektromotoren en van elektrische generatoren en transformatoren' },
    { value: '27120', label: '27120 - Vervaardiging van schakel- en verdeelinrichtingen' },
    { value: '27200', label: '27200 - Vervaardiging van batterijen en accumulatoren' },
    { value: '27310', label: '27310 - Vervaardiging van kabels van optische vezels' },
    { value: '27320', label: '27320 - Vervaardiging van overige elektrische en elektronische kabels' },
    { value: '27330', label: '27330 - Vervaardiging van schakelaars, stekkers, stopcontacten e.d.' },
    { value: '27400', label: '27400 - Vervaardiging van elektrische lampen en verlichtingsapparaten' },
    { value: '27510', label: '27510 - Vervaardiging van elektrische huishoudelijke apparaten' },
    { value: '27520', label: '27520 - Vervaardiging van niet-elektrische huishoudelijke apparaten' },
    { value: '27900', label: '27900 - Vervaardiging van overige elektrische apparatuur' },
    {
        value: '28110',
        label: '28110 - Vervaardiging van motoren en turbines, met uitzondering van motoren voor luchtvaartuigen, motorvoertuigen en tweewielers',
    },
    { value: '28120', label: '28120 - Vervaardiging van hydraulische apparatuur' },
    { value: '28130', label: '28130 - Vervaardiging van overige pompen en compressoren' },
    { value: '28140', label: '28140 - Vervaardiging van overige kranen en kleppen' },
    { value: '28150', label: '28150 - Vervaardiging van lagers, tandwielen en overige drijfwerkelementen' },
    {
        value: '28210',
        label: '28210 - Vervaardiging van ovens en branders en van permanente verwarmingstoestellen voor huishoudelijk gebruik',
    },
    { value: '28220', label: '28220 - Vervaardiging van hijs-, hef- en transportwerktuigen' },
    { value: '28230', label: '28230 - Vervaardiging van kantoormachines en -uitrusting, met uitzondering van computers en randapparatuur' },
    { value: '28240', label: '28240 - Vervaardiging van pneumatisch en elektrisch handgereedschap' },
    { value: '28250', label: '28250 - Vervaardiging van machines en apparaten voor klimaatregeling, voor niet-huishoudelijk gebruik' },
    { value: '28290', label: '28290 - Vervaardiging van overige machines en apparaten voor algemeen gebruik, n.e.g.' },
    { value: '28300', label: '28300 - Vervaardiging van machines en werktuigen voor de land- en bosbouw' },
    { value: '28410', label: '28410 - Vervaardiging van niet-verspanende machines en gereedschapswerktuigen voor metaalbewerking' },
    { value: '28420', label: '28420 - Vervaardiging van overige gereedschapswerktuigen' },
    { value: '28910', label: '28910 - Vervaardiging van machines voor de metallurgie' },
    { value: '28920', label: '28920 - Vervaardiging van machines voor de winning van delfstoffen en voor de bouw' },
    { value: '28930', label: '28930 - Vervaardiging van machines voor de productie van voedings- en genotmiddelen' },
    { value: '28940', label: '28940 - Vervaardiging van machines voor de productie van textiel, kleding en leer' },
    { value: '28950', label: '28950 - Vervaardiging van machines voor de productie van papier en karton' },
    { value: '28960', label: '28960 - Vervaardiging van machines voor de kunststof- en rubberindustrie' },
    { value: '28970', label: '28970 - Vervaardiging van machines voor additieve productie, zoals 3D-printers' },
    { value: '28990', label: '28990 - Vervaardiging van overige machines, apparaten en werktuigen voor specifieke doeleinden (rest)' },
    { value: '29100', label: '29100 - Vervaardiging van motorvoertuigen' },
    { value: '29201', label: '29201 - Carrosseriebouw' },
    { value: '29202', label: '29202 - Vervaardiging van aanhangwagens en opleggers' },
    { value: '29310', label: '29310 - Vervaardiging van elektrische en elektronische benodigdheden voor motorvoertuigen' },
    { value: '29320', label: '29320 - Vervaardiging van overige onderdelen en toebehoren voor motorvoertuigen' },
    { value: '30110', label: '30110 - Bouw van civiele schepen en drijvend materieel' },
    { value: '30120', label: '30120 - Bouw van sport- en recreatievaartuigen' },
    { value: '30130', label: '30130 - Bouw van militaire schepen en vaartuigen' },
    { value: '30200', label: '30200 - Vervaardiging van rollend materieel voor spoorwegen' },
    { value: '30310', label: '30310 - Vervaardiging van civiele lucht- en ruimtevaartuigen en aanverwante toestellen' },
    { value: '30320', label: '30320 - Vervaardiging van militaire lucht- en ruimtevaartuigen en aanverwante toestellen' },
    { value: '30400', label: '30400 - Vervaardiging van militaire gevechtsvoertuigen' },
    { value: '30910', label: '30910 - Vervaardiging van motorfietsen' },
    { value: '30920', label: '30920 - Vervaardiging van fietsen en voertuigen voor personen met een fysieke beperking' },
    { value: '30990', label: '30990 - Vervaardiging van overige transportmiddelen, n.e.g.' },
    { value: '31000', label: '31000 - Vervaardiging van meubelen' },
    { value: '32110', label: '32110 - Slaan van munten' },
    { value: '32120', label: '32120 - Vervaardiging van juwelen en aanverwante artikelen' },
    { value: '32130', label: '32130 - Vervaardiging van imitatiesieraden en aanverwante artikelen' },
    { value: '32200', label: '32200 - Vervaardiging van muziekinstrumenten' },
    { value: '32300', label: '32300 - Vervaardiging van sportartikelen' },
    { value: '32400', label: '32400 - Vervaardiging van spellen en speelgoed' },
    { value: '32501', label: '32501 - Vervaardiging van tandheelkundige instrumenten en benodigdheden' },
    { value: '32502', label: '32502 - Vervaardiging van medische instrumenten en benodigdheden (niet tandheelkundig)' },
    { value: '32910', label: '32910 - Vervaardiging van borstelwaren' },
    { value: '32990', label: '32990 - Vervaardiging van overige goederen (rest)' },
    { value: '33110', label: '33110 - Reparatie en onderhoud van producten van metaal' },
    { value: '33121', label: '33121 - Reparatie en onderhoud van machines voor algemeen gebruik en van machine-onderdelen' },
    { value: '33122', label: '33122 - Reparatie en onderhoud van pneumatisch en elektrisch gereedschap en gereedschapswerktuigen' },
    { value: '33123', label: '33123 - Reparatie en onderhoud van machines voor een specifieke bedrijfstak' },
    { value: '33130', label: '33130 - Reparatie en onderhoud van elektronische en optische apparatuur' },
    { value: '33140', label: '33140 - Reparatie en onderhoud van elektrische apparatuur' },
    { value: '33150', label: '33150 - Reparatie en onderhoud van civiele schepen' },
    { value: '33160', label: '33160 - Reparatie en onderhoud van civiele lucht- en ruimtevaartuigen' },
    { value: '33170', label: '33170 - Reparatie en onderhoud van overige civiele transportmiddelen' },
    { value: '33180', label: '33180 - Reparatie en onderhoud van militaire gevechtsvoertuigen, schepen, lucht- en ruimtevaartuigen' },
    { value: '33190', label: '33190 - Reparatie en onderhoud van overige apparatuur' },
    { value: '33200', label: '33200 - Installatie van industriële machines en apparatuur' },
    { value: '35110', label: '35110 - Productie van elektriciteit uit niet-hernieuwbare bronnen' },
    { value: '35121', label: '35121 - Productie van elektriciteit uit windenergie' },
    { value: '35122', label: '35122 - Productie van elektriciteit door zonnecellen' },
    { value: '35123', label: '35123 - Productie van elektriciteit uit waterkracht, biomassa en overige hernieuwbare bronnen' },
    { value: '35130', label: '35130 - Transmissie van elektriciteit' },
    { value: '35140', label: '35140 - Distributie van elektriciteit' },
    { value: '35150', label: '35150 - Handel in elektriciteit' },
    { value: '35160', label: '35160 - Opslag van elektriciteit' },
    { value: '35210', label: '35210 - Productie van gas' },
    { value: '35220', label: '35220 - Distributie van gasvormige brandstoffen via leidingen' },
    { value: '35230', label: '35230 - Handel in gas via leidingen' },
    { value: '35240', label: '35240 - Opslag van gas als onderdeel van netwerkleveringsdiensten' },
    { value: '35300', label: '35300 - Productie en distributie van en handel in stoom en gekoelde lucht' },
    { value: '35400', label: '35400 - Activiteiten van makelaars en bemiddelaars voor elektriciteit en aardgas' },
    { value: '36000', label: '36000 - Winning, behandeling en distributie van water' },
    { value: '37000', label: '37000 - Afvalwaterinzameling en -behandeling' },
    { value: '38110', label: '38110 - Inzameling van niet-schadelijk afval' },
    { value: '38120', label: '38120 - Inzameling van schadelijk afval' },
    { value: '38210', label: '38210 - Terugwinning van materialen uit afval' },
    { value: '38220', label: '38220 - Winning van energie uit afval' },
    { value: '38230', label: '38230 - Overige terugwinning uit afval' },
    { value: '38310', label: '38310 - Verbranding zonder energieterugwinning' },
    { value: '38320', label: '38320 - Storten of permanent opslaan' },
    { value: '38330', label: '38330 - Overige afvalverwijdering' },
    { value: '39001', label: '39001 - Sanering van bodem en grondwater' },
    { value: '39002', label: '39002 - Overige sanering en afvalbeheer' },
    { value: '41000', label: '41000 - Burgerlijke en utiliteitsbouw' },
    { value: '42110', label: '42110 - Wegenbouw en stratenmaken' },
    { value: '42120', label: '42120 - Bouw van boven- en ondergrondse spoorwegen' },
    { value: '42130', label: '42130 - Bouw van bruggen en tunnels' },
    { value: '42210', label: '42210 - Leggen van rioleringen, buizen en pijpleidingen; aanleg van bronbemaling' },
    { value: '42220', label: '42220 - Leggen van elektriciteits- en telecommunicatiekabels' },
    { value: '42910', label: '42910 - Waterbouw' },
    { value: '42990', label: '42990 - Bouw van overige civieltechnische werken (rest)' },
    { value: '43110', label: '43110 - Slopen' },
    { value: '43120', label: '43120 - Bouwrijp maken van terreinen' },
    { value: '43130', label: '43130 - Proefboren en boren' },
    { value: '43211', label: '43211 - Installatie van zonnepanelen voor de productie van elektriciteit' },
    { value: '43212', label: '43212 - Overige elektrische installatie' },
    { value: '43221', label: '43221 - Loodgieters- en fitterswerk; installatie van sanitair' },
    { value: '43222', label: '43222 - Installatie van verwarmings- en luchtbehandelingsapparatuur' },
    { value: '43230', label: '43230 - Aanbrengen van isolatie' },
    { value: '43240', label: '43240 - Overige bouwinstallatie' },
    { value: '43310', label: '43310 - Stukadoorswerk' },
    { value: '43320', label: '43320 - Bouwtimmeren' },
    { value: '43330', label: '43330 - Afwerken van vloeren en wanden' },
    { value: '43340', label: '43340 - Schilderen en glaszetten' },
    { value: '43350', label: '43350 - Overige werkzaamheden in verband met de afwerking van gebouwen' },
    { value: '43410', label: '43410 - Dakdekken en bouwen van dakconstructies' },
    { value: '43420', label: '43420 - Overige gespecialiseerde bouwactiviteiten in de constructie van gebouwen' },
    { value: '43500', label: '43500 - Gespecialiseerde bouwactiviteiten op het gebied van civiele techniek' },
    { value: '43600', label: '43600 - Bemiddelingsdiensten voor gespecialiseerde bouwactiviteiten.' },
    { value: '43910', label: '43910 - Metselwerk' },
    { value: '43990', label: '43990 - Overige gespecialiseerde bouwactiviteiten, n.e.g.' },
    {
        value: '46110',
        label: '46110 - Handelsbemiddeling in de groothandel in landbouwproducten, levende dieren, textielgrondstoffen en halffabricaten',
    },
    { value: '46120', label: '46120 - Handelsbemiddeling in de groothandel in brandstoffen, ertsen, metalen en chemische producten' },
    { value: '46130', label: '46130 - Handelsbemiddeling in de groothandel in hout en bouwmaterialen' },
    {
        value: '46140',
        label: '46140 - Handelsbemiddeling in de groothandel in machines, apparaten en werktuigen voor de industrie en in schepen en luchtvaartuigen',
    },
    {
        value: '46150',
        label: '46150 - Handelsbemiddeling in de groothandel in meubelen, huishoudelijke artikelen en ijzerwaren',
    },
    {
        value: '46160',
        label: '46160 - Handelsbemiddeling in de groothandel in textiel, kleding, bont, schoeisel en lederwaren',
    },
    { value: '46170', label: '46170 - Handelsbemiddeling in de groothandel in voedings- en genotmiddelen' },
    { value: '46180', label: '46180 - Handelsbemiddeling in de groothandel in overige goederen' },
    { value: '46190', label: '46190 - Handelsbemiddeling in de niet-gespecialiseerde groothandel' },
    { value: '46211', label: '46211 - Groothandel in granen' },
    { value: '46212', label: '46212 - Groothandel in zaden, pootgoed en peulvruchten' },
    { value: '46213', label: '46213 - Groothandel in hooi, stro en ruwvoer' },
    { value: '46214', label: '46214 - Groothandel in meng- en krachtvoer' },
    { value: '46215', label: '46215 - Groothandel in veevoer (geen ruw-, meng- en krachtvoer)' },
    {
        value: '46216',
        label: '46216 - Groothandel in ruwe plantaardige en dierlijke oliën en vetten en oliehoudende grondstoffen',
    },
    { value: '46217', label: '46217 - Groothandel in ruwe tabak' },
    { value: '46218', label: '46218 - Groothandel in akkerbouwproducten en veevoer algemeen assortiment' },
    { value: '46219', label: '46219 - Groothandel in overige akkerbouwproducten' },
    { value: '46220', label: '46220 - Groothandel in bloemen en planten' },
    { value: '46231', label: '46231 - Groothandel in levend vee' },
    { value: '46232', label: '46232 - Groothandel in huisdieren, siervissen, siervogels en wilde dieren' },
    { value: '46241', label: '46241 - Groothandel in huiden en vellen' },
    { value: '46242', label: '46242 - Groothandel in leer en halffabrikaten van leer' },
    { value: '46311', label: '46311 - Groothandel in groenten en fruit' },
    { value: '46312', label: '46312 - Groothandel in consumptie-aardappelen' },
    { value: '46321', label: '46321 - Groothandel in vlees en vleesproducten' },
    { value: '46322', label: '46322 - Groothandel in vis en visproducten en schaal- en weekdieren' },
    { value: '46331', label: '46331 - Groothandel in zuivelproducten en spijsoliën en -vetten' },
    { value: '46332', label: '46332 - Groothandel in eieren' },
    { value: '46340', label: '46340 - Groothandel in dranken (met uitzondering van zuivel)' },
    { value: '46350', label: '46350 - Groothandel in tabaksproducten en rokersbenodigdheden' },
    { value: '46360', label: '46360 - Groothandel in suiker, chocolade en suikerwerk' },
    { value: '46370', label: '46370 - Groothandel in koffie, thee, cacao en specerijen' },
    { value: '46381', label: '46381 - Groothandel in snacks' },
    { value: '46382', label: '46382 - Gespecialiseerde groothandel in overige voedingsmiddelen (rest)' },
    { value: '46383', label: '46383 - Groothandel in bakkerijgrondstoffen' },
    {
        value: '46389',
        label: '46389 - Gespecialiseerde groothandel in overige grondstoffen en halffabricaten voor de voedings- en genotmiddelenindustrie (rest)',
    },
    {
        value: '46390',
        label: '46390 - Groothandel in voedingsmiddelen, dranken en overige genotmiddelen algemeen assortiment',
    },
    { value: '46411', label: '46411 - Groothandel in kledingstoffen en fournituren' },
    { value: '46412', label: '46412 - Groothandel in overige textiel' },
    { value: '46421', label: '46421 - Groothandel in bovenkleding' },
    { value: '46422', label: '46422 - Groothandel in werkkleding' },
    { value: '46423', label: '46423 - Groothandel in onderkleding' },
    { value: '46424', label: '46424 - Groothandel in schoenen' },
    { value: '46425', label: '46425 - Groothandel in kledingaccessoires' },
    { value: '46429', label: '46429 - Groothandel in textielwaren algemeen assortiment' },
    { value: '46431', label: '46431 - Groothandel in witgoed' },
    {
        value: '46432',
        label: '46432 - Groothandel in elektrische huishoudelijke apparatuur (geen witgoed, audio en video)',
    },
    { value: '46433', label: '46433 - Groothandel in audio- en video-apparatuur' },
    { value: '46434', label: '46434 - Groothandel in fotografische artikelen' },
    { value: '46435', label: '46435 - Groothandel in optische artikelen' },
    { value: '46441', label: '46441 - Groothandel in glas, porselein en aardewerk' },
    { value: '46442', label: '46442 - Groothandel in was-, poets- en reinigingsmiddelen' },
    { value: '46450', label: '46450 - Groothandel in parfums en cosmetica' },
    { value: '46461', label: '46461 - Groothandel in farmaceutische producten' },
    {
        value: '46462',
        label: '46462 - Groothandel in medische en tandheelkundige instrumenten, verpleeg- en orthopedische artikelen en laboratoriumbenodigdheden',
    },
    { value: '46471', label: '46471 - Groothandel in huishoudelijke, kantoor- en winkelmeubelen' },
    { value: '46472', label: '46472 - Groothandel in vloerbedekking' },
    { value: '46473', label: '46473 - Groothandel in verlichtingsartikelen' },
    { value: '46480', label: '46480 - Groothandel in juweliersartikelen en horloges' },
    { value: '46491', label: '46491 - Groothandel in fietsen' },
    { value: '46492', label: '46492 - Groothandel in watersportartikelen' },
    { value: '46493', label: '46493 - Groothandel in kampeerartikelen (geen caravans)' },
    { value: '46494', label: '46494 - Groothandel in speelgoed' },
    { value: '46495', label: '46495 - Groothandel in muziekinstrumenten' },
    { value: '46496', label: '46496 - Groothandel in sportartikelen (geen watersport)' },
    { value: '46497', label: '46497 - Groothandel in papier- en kartonwaren (geen verpakkingsmateriaal)' },
    { value: '46498', label: '46498 - Groothandel in boeken, tijdschriften en overig drukwerk' },
    { value: '46499', label: '46499 - Groothandel in overige consumentenartikelen (non-food) (rest)' },
    { value: '46500', label: '46500 - Groothandel in informatie- en communicatieapparatuur' },
    { value: '46610', label: '46610 - Groothandel in landbouwmachines, werktuigen en tractoren' },
    { value: '46620', label: '46620 - Groothandel in gereedschapswerktuigen' },
    { value: '46630', label: '46630 - Groothandel in machines voor de bouw' },
    { value: '46641', label: '46641 - Groothandel in intern transportmaterieel' },
    {
        value: '46642',
        label: '46642 - Groothandel in machines en apparaten voor de warmte-, koel- en vriestechniek, voor industrieel gebruik',
    },
    { value: '46643', label: '46643 - Groothandel in verbrandingsmotoren, pompen en compressoren' },
    { value: '46644', label: '46644 - Groothandel in appendages, technische toebehoren e.d.' },
    { value: '46645', label: '46645 - Groothandel in meet- en regelapparaten' },
    { value: '46646', label: '46646 - Groothandel in emballage voor industrieel gebruik' },
    { value: '46647', label: '46647 - Groothandel in scheepsbenodigdheden en visserij-artikelen' },
    {
        value: '46649',
        label: '46649 - Groothandel in overige machines, werktuigen en toebehoren voor industrie en handel (rest)',
    },
    { value: '46710', label: '46710 - Groothandel in motorvoertuigen' },
    { value: '46720', label: '46720 - Groothandel in onderdelen en toebehoren van motorvoertuigen' },
    { value: '46730', label: '46730 - Groothandel in motor- en bromfietsen, inclusief onderdelen en toebehoren hiervan' },
    { value: '46811', label: '46811 - Groothandel in vaste brandstoffen' },
    { value: '46812', label: '46812 - Groothandel in vloeibare en gasvormige brandstoffen' },
    { value: '46813', label: '46813 - Groothandel in minerale olieproducten (geen brandstoffen)' },
    { value: '46821', label: '46821 - Groothandel in metaalertsen' },
    { value: '46822', label: '46822 - Groothandel in ferrometalen en halffabrikaten daarvan' },
    { value: '46823', label: '46823 - Groothandel in non-ferrometalen en halffabrikaten daarvan' },
    { value: '46831', label: '46831 - Groothandel in hout en plaatmateriaal' },
    { value: '46832', label: '46832 - Groothandel in verf en verfwaren' },
    { value: '46833', label: '46833 - Groothandel in behang' },
    { value: '46834', label: '46834 - Groothandel in vlakglas' },
    { value: '46835', label: '46835 - Groothandel in zand en grind' },
    { value: '46836', label: '46836 - Groothandel in tegels en plavuizen' },
    { value: '46837', label: '46837 - Groothandel in sanitaire artikelen' },
    { value: '46838', label: '46838 - Groothandel gespecialiseerd in overige bouwmaterialen' },
    { value: '46839', label: '46839 - Groothandel in bouwmaterialen algemeen assortiment' },
    { value: '46841', label: '46841 - Groothandel in ijzer- en metaalwaren' },
    { value: '46842', label: '46842 - Groothandel in verwarmingsapparaten en sanitair installatiemateriaal' },
    { value: '46851', label: '46851 - Groothandel in chemische grondstoffen en chemicaliën voor industriële toepassing' },
    { value: '46852', label: '46852 - Groothandel in bestrijdingsmiddelen en meststoffen' },
    { value: '46861', label: '46861 - Groothandel in textielgrondstoffen en halffabrikaten daarvan' },
    { value: '46862', label: '46862 - Groothandel in papier en karton' },
    { value: '46869', label: '46869 - Groothandel in overige intermediaire producten (rest)' },
    { value: '46871', label: '46871 - Groothandel in autosloopmateriaal' },
    { value: '46872', label: '46872 - Groothandel in ijzer- en staalschroot en gebruikte non-ferrometalen' },
    { value: '46879', label: '46879 - Groothandel in overige gebruikte materialen en afvalstoffen' },
    { value: '46890', label: '46890 - Overige gespecialiseerde groothandel (rest)' },
    { value: '46901', label: '46901 - Niet-gespecialiseerde groothandel in consumentenartikelen' },
    { value: '46902', label: '46902 - Niet-gespecialiseerde groothandel in niet-consumentenartikelen' },
    {
        value: '47110',
        label: '47110 - Niet-gespecialiseerde detailhandel waarbij voedings- en genotmiddelen overheersen',
    },
    { value: '47120', label: '47120 - Overige niet-gespecialiseerde detailhandel' },
    { value: '47210', label: '47210 - Detailhandel in aardappelen, groenten en fruit' },
    { value: '47221', label: '47221 - Detailhandel in vlees en vleeswaren (niet voornamelijk wild en gevogelte)' },
    { value: '47222', label: '47222 - Detailhandel in wild en gevogelte' },
    { value: '47230', label: '47230 - Detailhandel in vis en schaal- en weekdieren' },
    { value: '47241', label: '47241 - Detailhandel in brood en banket' },
    { value: '47242', label: '47242 - Detailhandel in chocolade en suikerwerk' },
    { value: '47250', label: '47250 - Detailhandel in dranken' },
    { value: '47260', label: '47260 - Detailhandel in tabaksproducten en aanverwante artikelen' },
    { value: '47271', label: '47271 - Detailhandel in kaas' },
    { value: '47272', label: '47272 - Detailhandel in natuurvoeding en reformartikelen' },
    { value: '47273', label: '47273 - Detailhandel in buitenlandse voedingsmiddelen' },
    { value: '47279', label: '47279 - Gespecialiseerde detailhandel in overige voedings- en genotmiddelen (rest)' },
    { value: '47300', label: '47300 - Detailhandel in voertuigbrandstof' },
    { value: '47401', label: '47401 - Detailhandel in computers, randapparatuur en software' },
    { value: '47402', label: '47402 - Detailhandel in telecommunicatieapparatuur' },
    { value: '47403', label: '47403 - Detailhandel in audio- en videoapparatuur' },
    { value: '47404', label: '47404 - Detailhandel in een algemeen assortiment van consumentenelektronica' },
    { value: '47511', label: '47511 - Detailhandel in kledingsstoffen' },
    { value: '47512', label: '47512 - Detailhandel in huishoudtextiel' },
    { value: '47513', label: '47513 - Detailhandel in breiwol, handwerken en fournituren' },
    { value: '47521', label: '47521 - Detailhandel in ijzerwaren en gereedschappen' },
    { value: '47522', label: '47522 - Detailhandel in verf, verfwaren en behang' },
    { value: '47523', label: '47523 - Detailhandel in houten bouw- en tuinmaterialen' },
    { value: '47524', label: '47524 - Detailhandel in tegels' },
    { value: '47525', label: '47525 - Detailhandel in parket-, laminaat- en kurkvloeren' },
    { value: '47526', label: '47526 - Detailhandel gespecialiseerd in overige doe-het-zelfartikelen' },
    { value: '47527', label: '47527 - Detailhandel in bouwmaterialen algemeen assortiment' },
    { value: '47530', label: '47530 - Detailhandel in tapijten en overige vloerbedekking en wandbekleding' },
    { value: '47541', label: '47541 - Detailhandel in witgoed' },
    { value: '47542', label: '47542 - Detailhandel in naai- en breimachines' },
    { value: '47543', label: '47543 - Detailhandel in overige elektrische huishoudelijke apparatuur' },
    { value: '47544', label: '47544 - Detailhandel in onderdelen voor elektrische huishoudelijke apparatuur' },
    { value: '47551', label: '47551 - Detailhandel in meubelen' },
    { value: '47552', label: '47552 - Detailhandel in verlichtingsartikelen' },
    { value: '47553', label: '47553 - Detailhandel in artikelen voor woninginrichting algemeen assortiment' },
    { value: '47554', label: '47554 - Detailhandel in keukens' },
    { value: '47555', label: '47555 - Detailhandel in glas-, porselein- en aardewerk' },
    { value: '47556', label: '47556 - Detailhandel in babyartikelen' },
    { value: '47557', label: '47557 - Detailhandel gespecialiseerd in overige huishoudelijke artikelen (rest)' },
    { value: '47558', label: '47558 - Detailhandel in huishoudelijke artikelen algemeen assortiment' },
    { value: '47610', label: '47610 - Detailhandel in boeken' },
    { value: '47620', label: '47620 - Detailhandel in kranten, tijdschriften en kantoorartikelen' },
    { value: '47631', label: '47631 - Detailhandel in fietsen' },
    { value: '47632', label: '47632 - Detailhandel in watersportartikelen' },
    { value: '47633', label: '47633 - Detailhandel in sportartikelen (geen watersport)' },
    { value: '47634', label: '47634 - Detailhandel in kampeerartikelen (geen caravans)' },
    { value: '47640', label: '47640 - Detailhandel in spellen en speelgoed' },
    { value: '47690', label: '47690 - Detailhandel in overige cultuur- en recreatieartikelen' },
    { value: '47711', label: '47711 - Detailhandel in herenkleding' },
    { value: '47712', label: '47712 - Detailhandel in dameskleding' },
    { value: '47713', label: '47713 - Detailhandel in kleding en kledingaccessoires (algemeen assortiment)' },
    { value: '47714', label: '47714 - Detailhandel in baby- en kinderkleding' },
    { value: '47715', label: '47715 - Detailhandel in onderkleding, lingerie en dergelijke' },
    { value: '47716', label: '47716 - Detailhandel in kledingaccessoires' },
    { value: '47721', label: '47721 - Detailhandel in schoenen' },
    { value: '47722', label: '47722 - Detailhandel in lederwaren en reisartikelen' },
    { value: '47730', label: '47730 - Detailhandel in farmaceutische artikelen' },
    { value: '47741', label: '47741 - Detailhandel in drogisterij-artikelen' },
    { value: '47742', label: '47742 - Detailhandel in medische en orthopedische artikelen' },
    { value: '47743', label: '47743 - Detailhandel in corrigerende brillen, lenzen en zonnebrillen' },
    { value: '47750', label: '47750 - Detailhandel in parfums en cosmetica' },
    { value: '47761', label: '47761 - Detailhandel in bloemen en planten, zaden en tuinbenodigdheden' },
    { value: '47762', label: '47762 - Detailhandel in dieren en dierbenodigdheden' },
    { value: '47770', label: '47770 - Detailhandel in horloges en juwelen' },
    { value: '47781', label: '47781 - Detailhandel in fotografische artikelen' },
    { value: '47789', label: '47789 - Detailhandel gespecialiseerd in overige nieuwe artikelen (rest)' },
    { value: '47791', label: '47791 - Detailhandel in antiek' },
    { value: '47792', label: '47792 - Detailhandel in tweedehands kleding' },
    { value: '47793', label: '47793 - Detailhandel in tweedehands goederen (geen kleding)' },
    { value: '47810', label: '47810 - Detailhandel in motorvoertuigen' },
    { value: '47820', label: '47820 - Detailhandel in onderdelen en toebehoren van motorvoertuigen' },
    {
        value: '47830',
        label: '47830 - Detailhandel in motor- en bromfietsen, inclusief onderdelen en toebehoren hiervan',
    },
    { value: '47910', label: '47910 - Bemiddelingsactiviteiten in verband met de niet-gespecialiseerde detailhandel' },
    { value: '47920', label: '47920 - Bemiddelingsactiviteiten voor de gespecialiseerde detailhandel' },
    { value: '49110', label: '49110 - Personenvervoer per trein' },
    { value: '49120', label: '49120 - Overig personenvervoer per spoor' },
    { value: '49200', label: '49200 - Goederenvervoer per spoor' },
    { value: '49310', label: '49310 - Personenvervoer over de weg met dienstregeling' },
    { value: '49320', label: '49320 - Personenvervoer over de weg zonder dienstregeling' },
    { value: '49330', label: '49330 - Personenvervoer op aanvraag per voertuig met chauffeur' },
    { value: '49340', label: '49340 - Personenvervoer met kabelbanen en skiliften' },
    { value: '49390', label: '49390 - Overig personenvervoer over land, n.e.g.' },
    { value: '49410', label: '49410 - Goederenvervoer over de weg (met uitzondering van verhuisbedrijven)' },
    { value: '49420', label: '49420 - Activiteiten van verhuisbedrijven' },
    { value: '49500', label: '49500 - Transport via pijpleidingen' },
    { value: '50100', label: '50100 - Personenvervoer over zee- en kustwateren' },
    { value: '50201', label: '50201 - Goederenvervoer over zee- en kustwateren door middel van vracht- en tankvaart' },
    { value: '50202', label: '50202 - Goederenvervoer over zee- en kustwateren door middel van sleepvaart' },
    { value: '50300', label: '50300 - Personenvervoer over binnenwateren' },
    { value: '50401', label: '50401 - Goederenvervoer over binnenwateren door middel van vrachtvaart' },
    { value: '50402', label: '50402 - Goederenvervoer over binnenwateren door middel van tankvaart' },
    { value: '50403', label: '50403 - Goederenvervoer over binnenwateren door middel van sleep- en duwvaart' },
    { value: '51100', label: '51100 - Personenvervoer door de lucht' },
    { value: '51210', label: '51210 - Goederenvervoer door de lucht' },
    { value: '51220', label: '51220 - Ruimtevaart' },
    { value: '52101', label: '52101 - Opslag in tanks' },
    { value: '52102', label: '52102 - Opslag in koelhuizen e.d.' },
    { value: '52109', label: '52109 - Opslag in distributiecentra en overige opslag (niet in tanks, koelhuizen e.d.)' },
    { value: '52210', label: '52210 - Dienstverlening voor vervoer over land' },
    { value: '52220', label: '52220 - Dienstverlening voor vervoer over water' },
    { value: '52230', label: '52230 - Dienstverlening voor de luchtvaart' },
    { value: '52241', label: '52241 - Laad-, los- en overslagactiviteiten voor zeevaart' },
    { value: '52242', label: '52242 - Laad-, los- en overslagactiviteiten niet voor zeevaart' },
    { value: '52250', label: '52250 - Logistieke diensten: vrachtafhandeling' },
    { value: '52260', label: '52260 - Andere vervoerondersteunende activiteiten: documentenafhandeling' },
    { value: '52310', label: '52310 - Bemiddelingsactiviteiten in verband met goederenvervoer' },
    { value: '52320', label: '52320 - Bemiddelingsactiviteiten in verband met personenvervoer' },
    { value: '53100', label: '53100 - Postdiensten met universele dienstverplichting' },
    { value: '53201', label: '53201 - Post- en pakketbezorgdiensten zonder universele dienstverplichting' },
    { value: '53202', label: '53202 - Activiteiten van koeriers' },
    { value: '53300', label: '53300 - Bemiddelingsactiviteiten in verband met post- en koeriersdiensten' },
    { value: '55101', label: '55101 - Exploitatie van hotel-restaurants' },
    { value: '55102', label: '55102 - Exploitatie van hotels (geen hotel-restaurants), pensions en conferentie-oorden' },
    { value: '55201', label: '55201 - Verhuur van vakantiehuisjes en appartementen' },
    {
        value: '55202',
        label: '55202 - Exploitatie van jeugdherbergen , vakantiekampen, groepsaccommodaties en overige korte-verblijfsaccommodaties',
    },
    { value: '55300', label: '55300 - Exploitatie van kampeerterreinen' },
    { value: '55400', label: '55400 - Bemiddelingsactiviteiten in verband met tijdelijke accommodaties' },
    { value: '55900', label: '55900 - Overige logiesverstrekking' },
    { value: '56111', label: '56111 - Exploitatie van restaurants' },
    { value: '56112', label: "56112 - Exploitatie van fastfoodrestaurants, cafetaria's, ijssalons en dergelijke" },
    { value: '56120', label: '56120 - Exploitatie van mobiele eetgelegenheden' },
    { value: '56210', label: '56210 - Cateringdiensten op evenementen' },
    {
        value: '56220',
        label: '56220 - Cateringdiensten op contractbasis en overige diensten in verband met drank en maaltijden',
    },
    { value: '56300', label: '56300 - Exploitatie van drinkgelegenheden' },
    { value: '56400', label: '56400 - Bemiddelingsactiviteiten in verband met drank en maaltijden' },
    { value: '58110', label: '58110 - Uitgeven van boeken' },
    { value: '58120', label: '58120 - Uitgeven van kranten' },
    { value: '58130', label: '58130 - Uitgeven van tijdschriften' },
    {
        value: '58190',
        label: '58190 - Overige activiteiten van uitgeverijen, met uitzondering van het uitgeven van software',
    },
    { value: '58210', label: '58210 - Uitgeven van computerspellen' },
    { value: '58290', label: '58290 - Uitgeven van overige software' },
    { value: '59111', label: '59111 - Productie van films (geen televisiefilms)' },
    { value: '59112', label: '59112 - Productie van televisieprogramma’s' },
    {
        value: '59120',
        label: '59120 - Activiteiten in verband met films en video- en televisieprogramma’s na de productie',
    },
    { value: '59130', label: '59130 - Distributie van films en televisie- en videoproducties' },
    { value: '59140', label: '59140 - Vertoning van films' },
    { value: '59200', label: '59200 - Maken en uitgeven van geluids- en muziekopnamen' },
    { value: '60100', label: '60100 - Uitzenden van radioprogramma’s en distributie van audio' },
    { value: '60200', label: '60200 - Samenstellen en uitzenden van televisieprogramma’s en distributie van video’s' },
    { value: '60310', label: '60310 - Activiteiten van persagentschappen' },
    { value: '60390', label: '60390 - Overige activiteiten op het gebied van de verspreiding van inhoud' },
    {
        value: '61100',
        label: '61100 - Activiteiten op het gebied van draadgebonden en draadloze telecommunicatie en telecommunicatie via satelliet',
    },
    {
        value: '61200',
        label: '61200 - Wederverkoop van telecommunicatie en bemiddelingsactiviteiten in verband met telecommunicatie',
    },
    { value: '61900', label: '61900 - Overige activiteiten op het gebied van telecommunicatie' },
    { value: '62100', label: '62100 - Ontwerpen van computerprogramma’s' },
    {
        value: '62200',
        label: '62200 - Activiteiten op het gebied van computerconsultancy en beheer van computerfaciliteiten',
    },
    { value: '62900', label: '62900 - Overige diensten op het gebied van informatietechnologie en computer' },
    {
        value: '63100',
        label: '63100 - Inrichten van computerinfrastructuur, gegevensverwerking, hosting en aanverwante activiteiten',
    },
    { value: '63910', label: '63910 - Activiteiten van webportalen' },
    { value: '63920', label: '63920 - Overige dienstverlenende activiteiten op het gebied van informatie' },
    { value: '64110', label: '64110 - Activiteiten van centrale banken' },
    { value: '64191', label: '64191 - Activiteiten van coöperatief georganiseerde banken' },
    { value: '64192', label: '64192 - Activiteiten van effectenkredietinstellingen' },
    { value: '64193', label: '64193 - Activiteiten van spaarbanken' },
    { value: '64194', label: '64194 - Activiteiten van algemene banken' },
    { value: '64210', label: '64210 - Activiteiten van financiële holdings' },
    { value: '64220', label: '64220 - Activiteiten van financieringsentiteiten binnen concernverband' },
    { value: '64310', label: '64310 - Activiteiten van geldmarkt- en niet-geldmarktbeleggingsfondsen' },
    { value: '64320', label: '64320 - Activiteiten van trust-, vastgoed- en agentschaprekeningen' },
    { value: '64910', label: '64910 - Financiële lease' },
    { value: '64921', label: '64921 - Activiteiten van hypotheekbanken en bouwfondsen' },
    { value: '64922', label: '64922 - Activiteiten van volkskredietbanken en commerciële financieringsmaatschappijen' },
    { value: '64923', label: '64923 - Activiteiten van participatiemaatschappijen' },
    { value: '64929', label: '64929 - Activiteiten van wisselmakelaars en overige kredietverstrekking (rest)' },
    { value: '64991', label: '64991 - Activiteiten van marketmakers' },
    {
        value: '64999',
        label: '64999 - Overige financiële dienstverlening, met uitzondering van verzekeringen en pensioenfondsen, n.e.g. (rest)',
    },
    { value: '65111', label: '65111 - Activiteiten van levensverzekeraars (geen herverzekeringen)' },
    { value: '65112', label: '65112 - Activiteiten van natura-uitvaartverzekeraars' },
    { value: '65121', label: '65121 - Activiteiten van schadeverzekeraars, met uitzondering van zorgverzekeraars' },
    { value: '65122', label: '65122 - Activiteiten van zorgverzekeraars' },
    { value: '65123', label: '65123 - Activiteiten van spaarkassen' },
    { value: '65200', label: '65200 - Activiteiten van herverzekeraars' },
    { value: '65301', label: '65301 - Activiteiten van bedrijfspensioenfondsen' },
    { value: '65302', label: '65302 - Activiteiten van ondernemingspensioenfondsen en -spaarfondsen' },
    { value: '65303', label: '65303 - Activiteiten van beroepspensioenfondsen' },
    { value: '65309', label: '65309 - Activiteiten van overige pensioenfondsen' },
    { value: '66110', label: '66110 - Beheer van financiële markten' },
    { value: '66120', label: '66120 - Bemiddeling in effecten- en goederencontracten' },
    { value: '66191', label: '66191 - Activiteiten van administratiekantoren voor aandelen en obligaties' },
    {
        value: '66199',
        label: '66199 - Overige ondersteunende activiteiten voor financiële diensten, met uitzondering van verzekeringen en pensioenfondsen (rest)',
    },
    { value: '66210', label: '66210 - Activiteiten van risicoanalisten en schadetaxateurs' },
    { value: '66220', label: '66220 - Activiteiten van verzekeringsagenten, makelaars en assurantietussenpersonen' },
    { value: '66291', label: '66291 - Activiteiten van verzekeringsbeurzen' },
    {
        value: '66292',
        label: '66292 - Activiteiten van actuariële en pensioenadviesbureaus; beheer en administratie van pensioenvermogens',
    },
    { value: '66293', label: '66293 - Activiteiten van waarborgfondsen' },
    {
        value: '66299',
        label: '66299 - Overige ondersteunende activiteiten in verband met verzekeringen en pensioenfondsen (rest)',
    },
    { value: '66300', label: '66300 - Vermogensbeheer' },
    { value: '68110', label: '68110 - Handel in eigen onroerend goed' },
    { value: '68120', label: '68120 - Projectontwikkeling' },
    { value: '68201', label: '68201 - Activiteiten van woningbouwverenigingen en -stichtingen' },
    { value: '68202', label: '68202 - Verhuur en exploitatie van overige woonruimte' },
    { value: '68203', label: '68203 - Verhuur en exploitatie van onroerend goed (niet van woonruimte)' },
    { value: '68310', label: '68310 - Bemiddeling in verband met exploitatie van en handel in onroerend goed' },
    {
        value: '68320',
        label: '68320 - Overige bemiddeling in en beheer van onroerend goed voor een vast bedrag of op contractbasis',
    },
    { value: '69101', label: '69101 - Activiteiten van advocaten, bewindvoerders en curatoren' },
    { value: '69102', label: '69102 - Rechtskundig advies' },
    { value: '69103', label: '69103 - Activiteiten van notarissen' },
    { value: '69104', label: '69104 - Activiteiten van deurwaarders' },
    { value: '69105', label: '69105 - Activiteiten van octrooibureaus' },
    { value: '69201', label: '69201 - Activiteiten van registeraccountants' },
    { value: '69202', label: '69202 - Activiteiten van accountants-administratieconsulenten' },
    { value: '69203', label: '69203 - Activiteiten van boekhouders' },
    { value: '69204', label: '69204 - Belastingadvisering' },
    { value: '69209', label: '69209 - Overige diensten op het gebied van boekhouding' },
    { value: '70101', label: '70101 - Concerndiensten binnen eigen concern' },
    { value: '70102', label: '70102 - Overige activiteiten van hoofdkantoren' },
    { value: '70201', label: '70201 - Activiteiten van organisatie-adviesbureaus' },
    {
        value: '70202',
        label: '70202 - Advisering op het gebied van management en bedrijfsvoering (geen public relations en organisatie-adviesbureaus)',
    },
    { value: '71111', label: '71111 - Activiteiten van architecten (geen interieurarchitecten)' },
    { value: '71112', label: '71112 - Activiteiten van interieurarchitecten' },
    { value: '71120', label: '71120 - Activiteiten van ingenieurs en overig technisch ontwerp en advies' },
    { value: '71201', label: '71201 - Keuring en controle van agrarische producten en voedingsmiddelen' },
    { value: '71202', label: '71202 - Keuring en controle van machines, apparaten en materialen' },
    { value: '71203', label: '71203 - Overige keuring en controle' },
    { value: '72100', label: '72100 - Natuurwetenschappelijk onderzoek en experimentele ontwikkeling' },
    {
        value: '72200',
        label: '72200 - Onderzoek en experimentele ontwikkeling op het gebied van de maatschappij- en geesteswetenschappen',
    },
    { value: '73110', label: '73110 - Activiteiten van reclamebureaus' },
    { value: '73120', label: '73120 - Handel in advertentieruimte en -tijd' },
    { value: '73200', label: '73200 - Markt- en opinieonderzoek' },
    {
        value: '73300',
        label: '73300 - Activiteiten van adviesbureaus op het gebied van public relations en communicatie',
    },
    { value: '74110', label: '74110 - Ontwerpen van industriële producten en mode' },
    { value: '74120', label: '74120 - Grafisch ontwerp en visuele communicatie' },
    { value: '74130', label: '74130 - Interieurontwerp' },
    { value: '74140', label: '74140 - Overige gespecialiseerde ontwerpactiviteiten' },
    { value: '74200', label: '74200 - Activiteiten op het gebied van fotografie' },
    { value: '74300', label: '74300 - Activiteiten van vertalers en tolken' },
    { value: '74910', label: '74910 - Bemiddeling in en het in de handel brengen van octrooien' },
    { value: '74990', label: '74990 - Overige specialistische zakelijke dienstverlening, n.e.g.' },
    { value: '75000', label: '75000 - Veterinaire dienstverlening' },
    {
        value: '77111',
        label: '77111 - Verhuur en lease van personenauto’s en andere lichte motorvoertuigen (geen operational lease)',
    },
    { value: '77112', label: '77112 - Operational lease van personenauto’s en andere lichte motorvoertuigen' },
    { value: '77120', label: '77120 - Verhuur en lease van vrachtwagens, autobussen, campers en aanhangwagens' },
    { value: '77210', label: '77210 - Verhuur en lease van recreatie- en sportartikelen' },
    { value: '77221', label: '77221 - Verhuur van kleding' },
    { value: '77222', label: '77222 - Verhuur van  huishoudelijke artikelen' },
    { value: '77229', label: '77229 - Verhuur van overige consumentenartikelen (rest)' },
    { value: '77310', label: '77310 - Verhuur en lease van landbouwmachines en -werktuigen' },
    {
        value: '77320',
        label: '77320 - Verhuur en lease van machines en installaties voor de bouwnijverheid en de weg- en waterbouw',
    },
    { value: '77330', label: '77330 - Verhuur en lease van computers en kantoorapparatuur' },
    { value: '77340', label: '77340 - Verhuur en lease van schepen' },
    { value: '77350', label: '77350 - Verhuur en lease van luchtvaartuigen' },
    {
        value: '77390',
        label: '77390 - Verhuur en lease van overige machines en werktuigen en van overige goederen, n.e.g.',
    },
    {
        value: '77400',
        label: '77400 - Lease van intellectuele eigendom en vergelijkbare producten, met uitzondering van werken onder auteursrecht',
    },
    { value: '77510', label: '77510 - Bemiddeling in verband met verhuur en lease van auto’s, campers en aanhangwagens' },
    {
        value: '77520',
        label: '77520 - Bemiddeling in verband met verhuur en lease van overige materiële goederen en niet-financiële immateriële activa',
    },
    { value: '78100', label: '78100 - Arbeidsbemiddeling' },
    { value: '78201', label: '78201 - Activiteiten van uitzendbureaus' },
    { value: '78202', label: '78202 - Activiteiten van uitleenbureaus' },
    { value: '79110', label: '79110 - Activiteiten van reisbureaus' },
    { value: '79120', label: '79120 - Activiteiten van reisorganisatoren' },
    { value: '79900', label: '79900 - Overige activiteiten van reserveringsbureaus en aanverwante activiteiten' },
    { value: '80010', label: '80010 - Opsporings- en beveiligingsdiensten ter plaatse' },
    { value: '80090', label: '80090 - Beveiligingsactiviteiten, n.e.g.' },
    { value: '81100', label: '81100 - Facility management' },
    { value: '81210', label: '81210 - Interieurreiniging van gebouwen' },
    { value: '81221', label: '81221 - Glazenwassen' },
    { value: '81222', label: '81222 - Schoorsteenvegen' },
    { value: '81229', label: '81229 - Overige gespecialiseerde reiniging van gebouwen en industriële reiniging (rest)' },
    { value: '81230', label: '81230 - Overige reiniging' },
    { value: '81301', label: '81301 - Onderhoud van tuinen, parken en plantsoenen' },
    { value: '81302', label: '81302 - Natuurbeheer' },
    { value: '82100', label: '82100 - Administratieve en ondersteunende activiteiten ten behoeve van kantoren' },
    { value: '82200', label: '82200 - Activiteiten van callcenters' },
    { value: '82300', label: '82300 - Organisatie van congressen en beurzen' },
    { value: '82400', label: '82400 - Bemiddelingsactiviteiten in verband met zakelijke dienstverlening, n.e.g.' },
    { value: '82910', label: '82910 - Activiteiten van incasso- en kredietbureaus' },
    { value: '82920', label: '82920 - Activiteiten van verpakkingsbedrijven' },
    { value: '82990', label: '82990 - Overige zakelijke dienstverlening, n.e.g.' },
    { value: '84110', label: '84110 - Algemeen overheidsbestuur' },
    {
        value: '84121',
        label: '84121 - Openbaar bestuur van de zorg, onderwijs, cultuur en andere sociale diensten (met uitzondering van sociale werkplaatsen en banenpools sector overheid)',
    },
    { value: '84122', label: '84122 - Beheer van sociale werkplaatsen' },
    { value: '84123', label: '84123 - Beheer van werkgelegenheidsprojecten (banenpools)' },
    { value: '84130', label: '84130 - Openbaar bestuur op het gebied van het bedrijfsleven' },
    { value: '84210', label: '84210 - Diensten van Buitenlandse zaken' },
    { value: '84220', label: '84220 - Diensten van Defensie' },
    { value: '84231', label: '84231 - Rechtspraak' },
    { value: '84232', label: '84232 - Diensten van het Ministerie van Justitie en gevangeniswezen' },
    { value: '84240', label: '84240 - Diensten van Openbare orde en veiligheid' },
    { value: '84250', label: '84250 - Diensten van de Brandweer' },
    { value: '84300', label: '84300 - Diensten van Verplichte sociale verzekeringen' },
    { value: '85100', label: '85100 - Kleuteronderwijs' },
    { value: '85201', label: '85201 - Regulier basisonderwijs' },
    { value: '85202', label: '85202 - Speciaal basisonderwijs' },
    { value: '85203', label: '85203 - Speciaal onderwijs en voortgezet speciaal onderwijs' },
    { value: '85311', label: '85311 - Havo, vwo en vmbo' },
    { value: '85312', label: '85312 - Praktijkonderwijs' },
    { value: '85320', label: '85320 - Middelbaar beroepsonderwijs' },
    { value: '85330', label: '85330 - Postsecundair niet-tertiair onderwijs' },
    { value: '85401', label: '85401 - Hoger beroepsonderwijs' },
    { value: '85402', label: '85402 - Universitair onderwijs' },
    { value: '85510', label: '85510 - Sport- en recreatieonderwijs' },
    { value: '85521', label: '85521 - Activiteiten van dansscholen' },
    { value: '85522', label: '85522 - Kunstzinnige vorming van amateurs (geen dansscholen)' },
    { value: '85530', label: '85530 - Activiteiten van auto- en motorrijscholen' },
    { value: '85591', label: '85591 - Bedrijfsopleiding en -training' },
    { value: '85599', label: '85599 - Studiebegeleiding en overig onderwijs n.e.g.' },
    { value: '85610', label: '85610 - Bemiddeling op het gebied van academische ondersteuning en studiebegeleiding' },
    { value: '85690', label: '85690 - Onderwijsondersteunende activiteiten, n.e.g.' },
    { value: '86101', label: '86101 - Exploitatie van Universitair Medische Centra' },
    { value: '86102', label: '86102 - Algemene ziekenhuiszorg' },
    { value: '86103', label: '86103 - Overige ziekenhuiszorg' },
    {
        value: '86104',
        label: '86104 - Curatieve Geestelijke gezondheidszorg met verblijf (met uitzondering van activiteiten van verslavingsklinieken)',
    },
    { value: '86210', label: '86210 - Huisartsenzorg' },
    {
        value: '86221',
        label: '86221 - Medisch specialistische zorg zonder verblijf (met uitzondering van psychiatrische zorg)',
    },
    { value: '86222', label: '86222 - Psychiatrische zorg' },
    { value: '86230', label: '86230 - Tandheelkundige zorg' },
    { value: '86910', label: '86910 - Activiteiten van medische beeldvorming en medische laboratoria' },
    { value: '86920', label: '86920 - Ambulancezorg' },
    { value: '86930', label: '86930 - Psychologische zorg' },
    { value: '86941', label: '86941 - Verloskundige zorg' },
    { value: '86942', label: '86942 - Verpleging en verzorging thuis en kraamzorg' },
    { value: '86943', label: '86943 - Overige verpleging en verzorging' },
    { value: '86950', label: '86950 - Fysiotherapie en ergotherapie' },
    { value: '86960', label: '86960 - Alternatieve geneeskunde en oefentherapie' },
    { value: '86970', label: '86970 - Bemiddeling in de gezondheidszorg' },
    { value: '86991', label: '86991 - Arbozorg (inclusief activiteiten van zelfstandige bedrijfsartsen)' },
    { value: '86992', label: '86992 - Preventieve zorg' },
    { value: '86993', label: '86993 - Overige mondzorg' },
    { value: '86994', label: '86994 - Overige paramedische zorg' },
    { value: '86999', label: '86999 - Overige gezondheidszorg zonder verblijf, n.e.g.' },
    { value: '87100', label: '87100 - Verpleeghuiszorg' },
    { value: '87201', label: '87201 - Verstandelijke gehandicaptenzorg met verblijf' },
    {
        value: '87202',
        label: '87202 - Verblijfszorg voor mensen met een langdurige geestelijke gezondheidszorgvraag of een middelenverslaving',
    },
    { value: '87301', label: '87301 - Lichamelijke en zintuiglijke gehandicaptenzorg met verblijf' },
    { value: '87302', label: '87302 - Verblijfszorg met persoonlijke verzorging en begeleiding voor ouderen' },
    { value: '87910', label: '87910 - Bemiddeling in de verblijfszorg' },
    { value: '87991', label: '87991 - Jeugdzorg met verblijf' },
    { value: '87992', label: '87992 - Maatschappelijke opvang met verblijf' },
    { value: '88101', label: '88101 - Huishoudelijke hulp voor ouderen en mensen met een handicap' },
    { value: '88102', label: '88102 - Ondersteuning en begeleiding ouderen (inclusief dagactiviteiten)' },
    { value: '88103', label: '88103 - Ondersteuning en begeleiding mensen met een handicap (inclusief dagactiviteiten)' },
    { value: '88910', label: '88910 - Kinderopvang' },
    {
        value: '88991',
        label: '88991 - Ondersteuning en begeleiding jeugdigen zonder verblijf (inclusief dagactiviteiten)',
    },
    { value: '88992', label: '88992 - Sociaal-maatschappelijk welzijnswerk' },
    { value: '88999', label: '88999 - Overige welzijnszorg' },
    { value: '90110', label: '90110 - Literaire creatie en compositie van muziek' },
    { value: '90120', label: '90120 - Creatie van beeldende kunst' },
    { value: '90130', label: '90130 - Overige vormen van scheppende kunst' },
    { value: '90200', label: '90200 - Activiteiten op het gebied van uitvoerende kunst' },
    { value: '90310', label: '90310 - Exploitatie van theaters, schouwburgen en poppodia' },
    { value: '90391', label: '90391 - Uitvoerende en ondersteunende productie van scheppende en uitvoerende kunst' },
    { value: '90392', label: '90392 - Organisatie van festivals op het gebied van scheppende en uitvoerende kunst' },
    { value: '90399', label: '90399 - Overige ondersteunende activiteiten voor scheppende en uitvoerende kunst (rest)' },
    { value: '91111', label: '91111 - Activiteiten van openbare bibliotheken' },
    { value: '91119', label: '91119 - Activiteiten van overige culturele uitleencentra en bibliotheken' },
    { value: '91120', label: '91120 - Activiteiten van archieven' },
    { value: '91211', label: '91211 - Activiteiten van musea' },
    { value: '91219', label: '91219 - Activiteiten van overige presentatie- en expositieruimten' },
    { value: '91220', label: '91220 - Activiteiten met betrekking tot historische locaties en monumenten' },
    {
        value: '91300',
        label: '91300 - Instandhouding, restauratie en overige ondersteunende activiteiten voor cultureel erfgoed',
    },
    { value: '91410', label: '91410 - Activiteiten van botanische tuinen en dierentuinen' },
    { value: '91420', label: '91420 - Activiteiten op het gebied van beheer en instandhouding van natuurreservaten' },
    { value: '92000', label: '92000 - Exploitatie van loterijen, kansspelen en kansspelautomaten' },
    { value: '93111', label: '93111 - Exploitatie van zwembaden' },
    { value: '93112', label: '93112 - Exploitatie van sporthallen, sportzalen en gymzalen' },
    { value: '93113', label: '93113 - Exploitatie van sportvelden' },
    { value: '93114', label: '93114 - Exploitatie van maneges' },
    { value: '93119', label: '93119 - Exploitatie van overige sportaccommodaties' },
    { value: '93121', label: '93121 - Activiteiten van veldvoetbalclubs' },
    { value: '93122', label: '93122 - Activiteiten van tennisclubs' },
    { value: '93123', label: '93123 - Activiteiten van zaalsportclubs, zowel individueel als in teamverband' },
    { value: '93124', label: '93124 - Activiteiten van zwemclubs en onderwatersportclubs' },
    { value: '93129', label: '93129 - Activiteiten van overige sportclubs en omnisportclubs' },
    { value: '93130', label: '93130 - Activiteiten van fitnesscentra' },
    { value: '93191', label: '93191 - Activiteiten van beroepssportlieden' },
    { value: '93192', label: '93192 - Activiteiten van supportersverenigingen op het gebied van sport' },
    { value: '93193', label: '93193 - Organiseren van sportevenementen' },
    {
        value: '93194',
        label: '93194 - Activiteiten van overkoepelende organen en samenwerkings- en adviesorganen op het gebied van sport',
    },
    { value: '93199', label: '93199 - Overige sportactiviteiten (rest)' },
    { value: '93210', label: '93210 - Exploitatie van pret- en themaparken' },
    { value: '93291', label: '93291 - Exploitatie van jachthavens' },
    { value: '93292', label: '93292 - Exploitatie van kermisattracties' },
    { value: '93293', label: '93293 - Exploitatie van speelautomaten (met uitzondering van kansspelautomaten)' },
    { value: '93299', label: '93299 - Overige activiteiten op het gebied van ontspanning en recreatie (rest)' },
    { value: '94110', label: '94110 - Activiteiten van bedrijfs- en werkgeversorganisaties' },
    { value: '94120', label: '94120 - Activiteiten van beroepsorganisaties' },
    { value: '94200', label: '94200 - Activiteiten van werknemersorganisaties' },
    { value: '94910', label: '94910 - Activiteiten van levensbeschouwelijke organisaties' },
    { value: '94920', label: '94920 - Activiteiten van politieke organisaties' },
    { value: '94991', label: '94991 - Activiteiten van gezelligheidsverenigingen' },
    { value: '94992', label: '94992 - Activiteiten van hobbyclubs' },
    { value: '94993', label: '94993 - Activiteiten van steunfondsen (niet op het gebied van welzijnszorg)' },
    {
        value: '94994',
        label: '94994 - Activiteiten van vriendenkringen op het gebied van cultuur, fanclubs en overige kunstbevordering',
    },
    {
        value: '94995',
        label: '94995 - Activiteiten van overkoepelende organen en samenwerkings- en adviesorganen (niet op het gebied van sport en recreatie)',
    },
    { value: '94996', label: '94996 - Activiteiten van overige ideële organisaties n.e.g.' },
    { value: '94997', label: '94997 - Overige belangenbehartiging n.e.g.' },
    { value: '95100', label: '95100 - Reparatie en onderhoud van computers en communicatieapparatuur' },
    {
        value: '95210',
        label: '95210 - Reparatie en onderhoud van consumentenelektronica (met uitzondering van computers)',
    },
    {
        value: '95220',
        label: '95220 - Reparatie en onderhoud van huishoudelijke apparaten en van werktuigen voor gebruik in huis en tuin',
    },
    { value: '95230', label: '95230 - Reparatie en onderhoud van schoenen en lederwaren' },
    { value: '95240', label: '95240 - Reparatie en onderhoud van meubelen en stoffering' },
    { value: '95250', label: '95250 - Reparatie en onderhoud van uurwerken en sieraden' },
    { value: '95290', label: '95290 - Reparatie en onderhoud van consumentenartikelen, n.e.g.' },
    { value: '95311', label: '95311 - Algemene reparatie en onderhoud van motorvoertuigen' },
    { value: '95312', label: '95312 - Activiteiten van auto-onderdelenservicebedrijven' },
    { value: '95313', label: '95313 - Activiteiten van bandenservicebedrijven' },
    { value: '95314', label: '95314 - Reparatie van specifieke auto-onderdelen' },
    { value: '95315', label: '95315 - Carrosserieherstel' },
    { value: '95316', label: "95316 - Overige gespecialiseerde reparatie en slepen van auto's" },
    { value: '95320', label: '95320 - Reparatie en onderhoud van motorfietsen' },
    {
        value: '95400',
        label: '95400 - Bemiddelingsactiviteiten in verband met reparatie en onderhoud van computers, consumentenartikelen, motorvoertuigen en motorfietsen',
    },
    { value: '96100', label: '96100 - Wassen en chemisch reinigen van textiel en bontproducten' },
    { value: '96210', label: '96210 - Kappers- en barbiersactiviteiten' },
    { value: '96220', label: '96220 - Schoonheidsverzorging en overige schoonheidsbehandelingen' },
    { value: '96230', label: '96230 - Activiteiten van wellnesscentra en sauna’s' },
    { value: '96301', label: '96301 - Uitvaartverzorging' },
    { value: '96302', label: '96302 - Activiteiten van crematoria, mortuaria en begraafplaatsen' },
    { value: '96400', label: '96400 - Bemiddelingsactiviteiten op het gebied van persoonlijke dienstverlening' },
    { value: '96910', label: '96910 - Huishoudelijke persoonlijke dienstverlening' },
    { value: '96990', label: '96990 - Overige persoonlijke dienstverlening, n.e.g.' },
    { value: '97000', label: '97000 - Activiteiten van huishoudens als werkgever van huishoudelijk personeel' },
    {
        value: '98100',
        label: '98100 - Niet-gedifferentieerde productie van goederen door particuliere huishoudens voor eigen gebruik',
    },
    {
        value: '98200',
        label: '98200 - Niet-gedifferentieerde productie van diensten door particuliere huishoudens voor eigen gebruik',
    },
    { value: '99000', label: '99000 - Activiteiten van extraterritoriale organisaties en instanties' },
];

export function toAdminEntitySnelStart(snelStartAdministration: AdministratieApiSst): AdminEntity {
    return {
        id: undefined,
        administrationId: snelStartAdministration.id,
        name: snelStartAdministration.name,
        providerId: null,
        environmentId: null,
        rgs: snelStartAdministration.rgs?.rgsStatus ?? 'Unknown',
        clientId: undefined,
        taxPayerId: undefined,
    } as AdminEntity;
}

export function toAdminEntityBalanceProvider(context: BalanceProviderAdministrationSelectionContext): AdminEntity {
    return {
        id: undefined,
        administrationId: context.administration.id,
        name: `${context.administration.name} (${context.balanceProvider.name})`,
        providerId: context.balanceProvider.id,
        environmentId: context.environment?.id ?? null,
        rgs: 'Unknown',
        clientId: undefined,
        taxPayerId: undefined,
    } as AdminEntity;
}
